// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n/* 字体 */\n/* Colors\n-------------------------- */\n/* 尺寸\n-------------------------- */\n#app {\n  height: 100%;\n}\n.header {\n  position: fixed;\n  width: 100%;\n  z-index: 9999;\n  background-color: #ffffff;\n  box-sizing: border-box;\n}\n.page-inner {\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n}\n.footer {\n  background-color: #ffffff;\n}\n", ""]);
// Exports
module.exports = exports;
